import React, { useState, useRef, useEffect } from 'react';
import { useSplash } from '../../contexts/SplashContext';

const LanguageSwitch = ({ onLanguageChange }) => {
    const splashData = useSplash();
    const languages = splashData?.languages || [];
    const defaultLanguage = languages.find(lang => lang.default)?.code || languages[0]?.code || 'en';
    const [selectedLanguage, setSelectedLanguage] = useState(defaultLanguage);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLanguageChange = (langCode) => {
        setSelectedLanguage(langCode);
        setIsDropdownOpen(false);
        if (onLanguageChange) {
            onLanguageChange(langCode);
        }
    };

    const selectedLang = languages.find(l => l.code === selectedLanguage);

    return (
        <div className="input-group-append" ref={dropdownRef} style={{ width: 'auto' }}>
            <button
                type="button"
                className="btn btn-outline-secondary d-flex align-items-center"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
                <img 
                    src={selectedLang?.flag_pic} 
                    alt={selectedLang?.language} 
                    style={{ width: '20px', marginRight: '5px' }} 
                />
                {selectedLang?.language}
                <i className="fas fa-chevron-down ms-2"></i>
            </button>
            {isDropdownOpen && (
                <div className="language-dropdown">
                    {languages.map((lang) => (
                        <button
                            key={lang.code}
                            type="button"
                            className={`dropdown-item d-flex align-items-center ${selectedLanguage === lang.code ? 'active' : ''}`}
                            onClick={() => handleLanguageChange(lang.code)}
                        >
                            <img 
                                src={lang.flag_pic} 
                                alt={lang.language} 
                                style={{ width: '20px', marginRight: '10px' }} 
                            />
                            {lang.language}&nbsp;&nbsp;
                            {lang.default && <span className="ms-auto badge bg-primary">Default</span>}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitch; 